/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface AddNote200Response
 */
export interface AddNote200Response {
    /**
     * 
     * @type {string}
     * @memberof AddNote200Response
     */
    message?: string;
}


/**
 * Check if a given object implements the AddNote200Response interface.
 */
export function instanceOfAddNote200Response(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function AddNote200ResponseFromJSON(json: any): AddNote200Response {
    return AddNote200ResponseFromJSONTyped(json, false);
}

export function AddNote200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddNote200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function AddNote200ResponseToJSON(value?: AddNote200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
    };
}

